import React from 'react'
import { checkTextTranslation, getObject } from '../../utils/useful'

class TableSelectInput extends React.Component {
    state = {
    }




    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    getLabel(key) {
        // console.log(this.props.data)
        
        if (this.props.data || this.props.data ==0) {
            if (typeof this.props.data == 'object' || this.props.header?.information?.self) {
                if( this.props.header?.information?.self){
                    return getObject(this.props.fullValues, this.props.header?.information?.fields?.title) ? getObject(this.props.data, this.props.header?.information?.fields?.title) : getObject(this.props.data, this.props.header?.information?.fields?.description)

                }else{

                    return getObject(this.props.data, this.props.header?.information?.fields?.title) ? getObject(this.props.data, this.props.header?.information?.fields?.title) : getObject(this.props.data, this.props.header?.information?.fields?.description)
                }
            } else {
                if (this.props.header?.information?.items?.length) {
                    for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                        const item = this.props.header?.information?.items[i];
                        if (item.value == this.props.data  || (item.value2 && item.value2 == this.props.data)) {
                            return item[key]
                        }
                    }
                }else{
                    return this.props.data
                }
            }
        } else {
            if (this.props.header?.information?.default) {
                for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                    const item = this.props.header?.information?.items[i];
                    if (item.value == this.props.header?.information?.default) {
                        return item[key]
                    }
                }
            } else {
                return ' '
            }
        }

    }

    render() {
        return (
            <div className="w-100 h-100 flexcc">
                <p className="" style={{ color: this.getLabel("color") ? this.getLabel("color") : '', backgroundColor: this.getLabel("backgroundColor"), textOverflow: 'ellipsis', overflow: 'hidden', padding: '6px 14px', borderRadius: 30 }}>{this.getLabel("title")}</p>
            </div>
        )
    }
}

export default TableSelectInput;